import { FilespaceVersion } from '@lucidlink/dto/validation';
// The Lost&Found rescue tree exists exactly on V13+ filespaces: the creator builds its crypto
// material and the committer assembles the rows.
export const LOST_AND_FOUND_MIN_FILESPACE_VERSION = FilespaceVersion.V13;
